import FormAlerts from '@/shared/components/FormAlerts'
import { checkRequired } from '@/shared/utils/validation'
import forIn from 'lodash-es/forIn'
import { ValidationProvider, ValidationObserver, setInteractionMode } from 'vee-validate'

setInteractionMode('lazy')

export default {
  data () {
    return {
      invalidMsg: [],
      loading: false,
      errorTabs: [],
      uploadHeaders: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': window.csrfToken,
        Accept: 'application/json',
        'X-Socket-Id': window.Echo ? window.Echo.socketId() : null
      }
    }
  },

  components: {
    FormAlerts,
    ValidationProvider,
    ValidationObserver
  },

  methods: {
    checkRequired: (rules) => {
      return checkRequired(rules)
    },

    handleForm: function (formName, $event) {
      this.loading = true
      this.invalidMsg = []
      this.submitForm()
        .then(_ => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$refs[formName].reset()

          if (error.status === 422) { // validation error
            // eslint-disable-next-line prefer-const
            let serverSideErrors = {}
            forIn(error.data.errors, (err, field) => {
              if (!Array.isArray(err)) {
                err = [err]
              }
              this.invalidMsg.push(err[0])
              serverSideErrors[field] = [err[0]]
            })
            this.$refs[formName].setErrors(serverSideErrors)
          }
        })

      this.loading = false
    },

    clearInvalidMsg: function () {
      this.invalidMsg = []
    },

    checkInvalidTabs: function () {
      if (document.querySelector('form .el-tabs__nav') !== null) {
        const tabs = document.querySelectorAll('form .el-tab-pane')
        tabs.forEach((tab) => {
          this.checkTabHasErrors(tab)
        })
      }
    },

    checkTabHasErrors: function (tab) {
      const tabName = tab.getAttribute('id').replace('pane-', '')
      if (tab.querySelector('.el-form-item__error') !== null) {
        if (!this.errorTabs.includes(tabName)) {
          this.errorTabs.push(tabName)
        }
        return true
      } else {
        const ind = this.errorTabs.indexOf(tabName)
        if (ind !== -1) {
          this.errorTabs.splice(ind, 1)
        }
        return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/shared/mixins/forms.js